import { ApiModule } from '@core';
import type { ProductCalculatedData, ProductGroupAmountData } from '..';

export class OfferCalculatorApi extends ApiModule {
  protected endpoint = '/vantage/calculator';

  public calculateProductGroupPrice(data: ProductGroupAmountData) {
    return this.api.get<ProductCalculatedData[]>(`${this.endpoint}/${data.id}/pricecalc`, {
      params: { amount: data.amount }
    });
  }
}
